<script lang="ts">
    import { page } from "$app/stores";

    // Navigation links
    const navLinks = [
        { href: "/", title: "Home", label: "Home" },
        { href: "/order", title: "Pricing", label: "Pricing" },
        { href: "/contact", title: "Contact", label: "Contact" },
    ];

    // Phone number
    const phoneNumber = "+1 (800) 906-3777";
    const phoneLink = "tel:+18339063777";

    // Active link styling
    $: classesActive = (href: string) => (href === $page.url.pathname ? "!bg-primary-500 !text-white" : "");
</script>

<nav>
    <ul class="list-nav flex flex-row justify-center items-center gap-4 text-center">
        {#each navLinks as { href, title, label }}
            <li>
                <a class={classesActive(href)} {href} title="Go to {title} Page">
                    <span class="flex-auto">{label}</span>
                </a>
            </li>
        {/each}

        <li>
            <a class="text-sm" href={phoneLink} rel="noopener noreferrer" title="Call C2 Certification">
                <span class="flex-auto max-w-sm">{phoneNumber}</span>
            </a>
        </li>
    </ul>
</nav>
